/* Patina & Grace — scroll reveal + sticky header state.
   Adds .js to <html> first so CSS only hides content when we can show it again. */
(function () {
  'use strict';
  var root = document.documentElement;
  root.classList.add('js');

  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function revealAll(nodes) {
    for (var i = 0; i < nodes.length; i++) nodes[i].classList.add('is-visible');
  }

  function init() {
    var targets = document.querySelectorAll('.png-reveal:not(.is-visible)');
    if (!targets.length) return;

    // No IntersectionObserver, or the visitor asked for less motion: show everything.
    if (reduced || !('IntersectionObserver' in window)) {
      revealAll(targets);
      return;
    }

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-visible');
        io.unobserve(entry.target);
      });
    }, { rootMargin: '0px 0px -12% 0px', threshold: 0.08 });

    targets.forEach(function (el) { io.observe(el); });
  }

  // Header goes opaque once the page scrolls past a sentinel — no scroll listener.
  function initHeader() {
    var header = document.querySelector('.header, header');
    if (!header || !('IntersectionObserver' in window)) return;

    var sentinel = document.createElement('div');
    sentinel.setAttribute('aria-hidden', 'true');
    sentinel.style.cssText = 'position:absolute;top:0;left:0;width:1px;height:1px;pointer-events:none;';
    document.body.prepend(sentinel);

    new IntersectionObserver(function (entries) {
      root.classList.toggle('png-scrolled', !entries[0].isIntersecting);
    }, { threshold: 0 }).observe(sentinel);
  }

  function boot() { init(); initHeader(); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  // Theme editor re-renders sections without a page load.
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('shopify:block:select', init);
})();
